/* =====================================================================
   Stok görseller → public/img/stok/{ad}.webp
   Kaynak: iki kolaj (1536×1024) sharp ile parçalandı; boyutlar gerçek piksel.
   Parçalar küçük (en büyüğü ~445×350): kart kapağı, yazı içi yan görsel ve
   ikon için uygun; tam genişlik hero ya da OG görseli olarak kullanma.
   İkinci kolajdaki görseller (et-tabagi…salata-kase) turuncu Tilki arayüzüyle,
   hero görseliyle aynı dilde; ürün ekranı gereken yerde bunlar tercih edilir.
   ikon-* görsellerin zemini şeffaf (açık zemin rengi silindi); beyaz iç kısımlar da kısmen
   saydam, bu yüzden ikonları beyaz yüzeyde kullan.
   ===================================================================== */

const SIZES = {
  'kafe-ic-mekan': [339, 397],
  'qr-menu-telefon': [285, 397],
  'masa-qr-standi': [303, 397],
  'sadakat-puan-telefon': [280, 397],
  latte: [282, 397],
  'pos-tablet': [297, 282],
  'izgara-somon': [303, 282],
  'garson-tablet': [286, 282],
  'teras-aksam': [304, 282],
  'buyume-grafigi': [297, 282],
  'kahve-cekirdegi': [182, 124],
  feslegen: [180, 124],
  salata: [195, 124],
  'kirmizi-sarap': [137, 124],
  cheesecake: [169, 124],
  'restoran-masa': [161, 124],
  'aksam-yemegi': [191, 124],
  'temassiz-odeme': [174, 124],
  // İkinci kolaj (coklu-stok.png)
  'et-tabagi': [377, 349],
  'panel-tablet': [445, 349],
  'qr-menu-el': [308, 349],
  'musteri-qr': [377, 313],
  'sadakat-programi': [445, 313],
  'garson-siparis': [361, 313],
  sef: [377, 332],
  cihazlar: [445, 332],
  'salata-kase': [308, 332],
  'ikon-qr': [151, 151],
  'ikon-hediye': [158, 158],
  'ikon-pos': [169, 169],
  'ikon-sef': [145, 145],
  'ikon-kahve': [131, 131],
  'ikon-grafik': [118, 118],
  'ikon-sadakat': [133, 133],
  'ikon-servis': [150, 150],
};

// stock('latte', 'Latte art ile servis edilen kahve') → { src, width, height, alt }
export const stock = (name, alt = '') => {
  const [width, height] = SIZES[name];
  return { src: `/img/stok/${name}.webp`, width, height, alt };
};
